export default "__VITE_ASSET___mGY7wRE__"